export const SoftSkillData = [
  { skill: 'Problem-Solving & Critical Thinking', level: 9 },
  { skill: 'Communication Skills', level: 7 },
  { skill: 'Curiosity', level: 5 },
  { skill: 'Teamwork & Collaboration', level: 8 },
  { skill: 'Time Management', level: 7 },
  { skill: 'Attention to Detail', level: 8 }
]

export const SoftSkillData1 = [
  { skill: 'Self-Motivation & Independence', level: 9 },
  { skill: 'Adaptability to Change', level: 8 },
  { skill: 'Conflict Resolution', level: 7 },
  { skill: 'Patience', level: 8 },
  { skill: 'Leadership & Mentorship', level: 7 },
  { skill: 'Empathy', level: 8 }
]
